import { ApiRequest, queryClient } from '../baseService'

const BaseRoute = 'app/specialist-provider-number'

function GetListBySpecialist(specialistId) {
  return ApiRequest.get(`${BaseRoute}/by-specialist/${specialistId}`)
}

function Create(data) {
  queryClient.invalidateQueries([BaseRoute])
  return ApiRequest.post(`${BaseRoute}`, data)
}

function Update(id, data) {
  queryClient.invalidateQueries([BaseRoute, id])
  return ApiRequest.put(`${BaseRoute}/${id}`, data)
}

function Deactivate(id) {
  queryClient.invalidateQueries([BaseRoute, id])
  return ApiRequest.put(`${BaseRoute}/${id}/deactivate`)
}

function SetDefault(id) {
  queryClient.invalidateQueries([BaseRoute, id])
  return ApiRequest.put(`${BaseRoute}/${id}/set-default`)
}

const SpecialistProviderNumberService = {
  GetListBySpecialist,
  Create,
  Update,
  Deactivate,
  SetDefault,
}

export default SpecialistProviderNumberService
